import React from 'react';
import { Typography } from '@one-thd/sui-atomic-components';
// Component to display the pickup address in the LORP contact details step
export var LORPPickupAddress = function (_a) {
    var fulfillmentGroup = _a.fulfillmentGroup, isCompleteReturn = _a.isCompleteReturn;
    var returnAddress = (fulfillmentGroup.returnPickupAddress || {}).returnAddress;
    var _b = returnAddress || {}, firstName = _b.firstName, lastName = _b.lastName, addressLine1 = _b.addressLine1, addressLine2 = _b.addressLine2, city = _b.city, state = _b.state, zipCode = _b.zipCode;
    if (!(returnAddress === null || returnAddress === void 0 ? void 0 : returnAddress.addressLine1)) {
        return (React.createElement("div", { className: "md:sui-mb-[32px]", "data-testid": "lorp-no-address" },
            React.createElement(Typography, { variant: "body-base", color: "subtle" }, "No Address Provided")));
    }
    return (React.createElement("div", { className: "md:sui-mb-[32px]", "data-testid": "lorp-address" },
        React.createElement(Typography, { variant: "body-base", weight: "bold" },
            "Pickup ",
            isCompleteReturn ? 'Location' : 'Address',
            ":"),
        React.createElement("div", null,
            React.createElement(Typography, { variant: "body-base" }, "".concat(firstName !== null && firstName !== void 0 ? firstName : '', " ").concat(lastName !== null && lastName !== void 0 ? lastName : '')),
            React.createElement(Typography, { variant: "body-base" }, addressLine1),
            addressLine2 && (React.createElement(Typography, { variant: "body-base" }, addressLine2)),
            city && state && zipCode && (React.createElement(Typography, { variant: "body-base" }, "".concat(city, ", ").concat(state, " ").concat(zipCode))))));
};
